import i18next from '@bonanza-social/i18n';
import en from './en.json';
import fr from './fr.json';

i18next.addResources('en', 'auth', en);
i18next.addResources('fr', 'auth', fr);

declare global {
  interface RegisteredLocales {
    auth: typeof en;
  }
}
